import { create } from 'zustand';

type ActiveKey = string | null;

interface NavigationSystemState {
  activeKey: ActiveKey;
  pinned: boolean;
  openedGroupKeys: string[];
}

interface NavigationSystemStore {
  activeKey: ActiveKey;
  pinned: boolean;
  openedGroupKeys: string[];
  setActiveKey: (key?: ActiveKey) => void;
  setOpenedGroupKeys: (keys: string[]) => void;
  setPinned: (pinned: boolean) => void;
}

const initialState: NavigationSystemState = {
  activeKey: null,
  pinned: true,
  openedGroupKeys: ['데이터'],
};

const useNavigationStore = create<NavigationSystemStore>((set, get) => ({
  ...initialState,

  setActiveKey: (key) => set(() => ({ activeKey: key })),
  setOpenedGroupKeys: (keys) => set(() => ({ openedGroupKeys: keys })),
  setPinned: (pinned) => {
    set(() => ({ pinned }));
    window.localStorage.setItem('clobe-nav-pinned', JSON.stringify(pinned));
  },
}));

export default useNavigationStore;
